export const Accordion = ({ children }: { children: any }) => {
  return (
    <div className="overflow-hidden">
      <ul className="list-none">{children}</ul>
    </div>
  )
}
